import Button from "@/utils/ui/Button/Button";
import { formatEntityName } from "@/utils/utilFunctions/entityName";
import React, { useEffect, useRef, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import BackIcon from "../../../assets/icons/svg/arrow_back.svg?react";
import { RootState } from "../../../store";
import { useClickOutside } from "../../../utils";
import {
  createCategory,
  updateCategory,
  getCategoryList,
} from "@/store/media/media.action";
import CustomSelect from "@/components/Select/Select";
import { Tab, Tabs } from "react-bootstrap";

import "../Setting/Setting.css";

const sections = [
  { to: "/meta-managements/language", icon: "bi-translate", label: "Language" },
  { to: "/meta-managements/category", icon: "bi-tags-fill", label: "Category" },
];

interface MetaDefaultProps {
  isFromProductForm?: boolean;
  onMetaChange?: (data: { language: any[]; category: any[] }) => void;
  preSelectedMetaLanguage?: any[];
  preSelectedMetaCategory?: any[];
}

const MetaDefault = ({
  createCategory,
  updateCategory,

  getCategoryList,
  bunchCategoryList,
  bunchLanguageList,
  bunchProductList,
  isFromProductForm = false,
  onMetaChange,
  preSelectedMetaLanguage,
  preSelectedMetaCategory,
}: Props & MetaDefaultProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const showBackArrow = new URLSearchParams(location.search).has("settings");
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const moreOptionsRef = useRef<HTMLDivElement>(null);

  const [selectedMeta, setSelectedMeta] = useState<any>([]);
  const [formState, setFormState] = useState<{
    isDirty: boolean;
    isValid: boolean;
  }>({
    isDirty: false,
    isValid: false,
  });
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const [search, setSearch] = useState("");
  const [metaSearch, setMetaSearch] = useState("");
  const [expandedCategory, setExpandedCategory] = useState<string | null>(null);

  const [metaList, setMetaList] = useState<any>([]);
  const [langMetaList, setLangMetaList] = useState<any>([]);
  const [categoryMetaList, setCategoryMetaList] = useState<any>([]);
  const [selectedLangMeta, setSelectedLangMeta] = useState<any>([]);
  const [selectedCategoryMeta, setSelectedCategoryMeta] = useState<any>([]);

  const [hasName, setHasName] = useState<boolean>(false);
  const [isLanguage, setIsLanguage] = useState<boolean>(true);
  const [isContentExpanded, setIsContentExpanded] = useState<boolean>(false);

  // Drag and drop state
  const [draggedItem, setDraggedItem] = useState<any | null>(null);
  const [dragOverItem, setDragOverItem] = useState<any | null>(null);

  const handleHasName = (e: any) => {
    setHasName(e);
  };

  useEffect(() => {
    if (isFromProductForm) {
      const temp =
        preSelectedMetaLanguage
          ?.map((id: any) =>
            bunchLanguageList.find((item: any) => item.id === id)
          )
          .filter((item: any) => item !== undefined) || [];

      setSelectedLangMeta(temp);
      const temp2 =
        preSelectedMetaCategory
          ?.map((id: any) =>
            bunchCategoryList.find((item: any) => item.id === id)
          )
          .filter((item: any) => item !== undefined) || [];
      setSelectedCategoryMeta(temp2);
    }
  }, [
    preSelectedMetaLanguage,
    preSelectedMetaCategory,
    bunchLanguageList,
    bunchCategoryList,
  ]);

  useEffect(() => {
    if (isLanguage) {
      setSelectedMeta(selectedLangMeta);
    } else {
      setSelectedMeta(selectedCategoryMeta);
    }
  }, [isLanguage, selectedLangMeta, selectedCategoryMeta]);

  useEffect(() => {
    if (isFromProductForm) {
      const langIds = selectedLangMeta.map((item: any) => item.id);
      const categoryIds = selectedCategoryMeta.map((item: any) => item.id);
      onMetaChange?.({ language: langIds, category: categoryIds });
    }
  }, [selectedLangMeta, selectedCategoryMeta]);

  const handleClick = (label: string) => {
    if (label === "Language") {
      setIsLanguage(true);
      setIsContentExpanded(true);
      setMetaList(bunchLanguageList);
      setLangMetaList(
        bunchLanguageList.filter(
          (item: any) =>
            !selectedLangMeta.some((selected: any) => selected.id === item.id)
        )
      );
    } else if (label === "Category") {
      setIsLanguage(false);
      setIsContentExpanded(true);
      setMetaList(bunchCategoryList);
      setCategoryMetaList(
        bunchCategoryList.filter(
          (item: any) =>
            !selectedCategoryMeta.some(
              (selected: any) => selected.id === item.id
            )
        )
      );
    }
  };

  useEffect(() => {
    if (isLanguage) {
      setLangMetaList(
        bunchLanguageList.filter(
          (item: any) =>
            !selectedLangMeta.some((selected: any) => selected.id === item.id)
        )
      );
    } else {
      setCategoryMetaList(
        bunchCategoryList.filter(
          (item: any) =>
            !selectedCategoryMeta.some(
              (selected: any) => selected.id === item.id
            )
        )
      );
    }
  }, [
    bunchLanguageList,
    bunchCategoryList,
    isLanguage,
    selectedLangMeta,
    selectedCategoryMeta,
  ]);

  let filteredKeys: any[] = [];
  let filteredMeta: any[] = [];
  if (isLanguage) {
    filteredKeys = Array.isArray(langMetaList)
      ? langMetaList.filter((item: any) =>
          (item.name || "").toLowerCase().includes(search.toLowerCase())
        )
      : [];
    filteredMeta = Array.isArray(selectedLangMeta)
      ? selectedLangMeta.filter((item: any) =>
          (item.name || "").toLowerCase().includes(metaSearch.toLowerCase())
        )
      : [];
  } else {
    filteredKeys = Array.isArray(categoryMetaList)
      ? categoryMetaList.filter((item: any) =>
          (item.name || "").toLowerCase().includes(search.toLowerCase())
        )
      : [];
    filteredMeta = Array.isArray(selectedCategoryMeta)
      ? selectedCategoryMeta.filter((item: any) =>
          (item.name || "").toLowerCase().includes(metaSearch.toLowerCase())
        )
      : [];
  }

  useClickOutside(moreOptionsRef, () => setOpenDropdown(null));

  const handleDeleteMeta = (e: any, key: any) => {
    e.stopPropagation();
    if (isLanguage) {
      setSelectedLangMeta(
        selectedLangMeta.filter((meta: any) => meta.id !== key.id)
      );
    } else {
      setSelectedCategoryMeta(
        selectedCategoryMeta.filter((meta: any) => meta.id !== key.id)
      );
    }
    setSelectedMeta(selectedMeta.filter((meta: any) => meta.id !== key.id));
  };

  const handleMoveUp = (e: any, key: any) => {
    e.stopPropagation();
    const currentIndex = selectedMeta.findIndex(
      (meta: any) => meta.id === key.id
    );
    if (currentIndex > 0) {
      const newSelectedMeta = [...selectedMeta];
      // Swap with the item above
      [newSelectedMeta[currentIndex], newSelectedMeta[currentIndex - 1]] = [
        newSelectedMeta[currentIndex - 1],
        newSelectedMeta[currentIndex],
      ];
      if (isLanguage) {
        setSelectedLangMeta(newSelectedMeta);
      } else {
        setSelectedCategoryMeta(newSelectedMeta);
      }
      setSelectedMeta(newSelectedMeta);
    }
  };

  // Drag and drop handlers
  const handleDragStart = (e: React.DragEvent, item: any) => {
    setDraggedItem(item);
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/html", item.id);
  };

  const handleDragOver = (e: React.DragEvent, item: any) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    if (dragOverItem && dragOverItem.id !== item.id) {
      setDragOverItem(item);
    }
  };

  const handleDragLeave = (e: React.DragEvent) => {
    e.preventDefault();
    setDragOverItem(null);
  };

  const handleDrop = (e: React.DragEvent, dropTarget: any) => {
    e.preventDefault();
    if (draggedItem && draggedItem.id !== dropTarget.id) {
      const draggedIndex = selectedMeta.findIndex(
        (meta: any) => meta.id === draggedItem.id
      );
      const dropIndex = selectedMeta.findIndex(
        (meta: any) => meta.id === dropTarget.id
      );

      if (draggedIndex === -1 || dropIndex === -1) {
        return;
      }

      const newSelectedMeta = [...selectedMeta];
      newSelectedMeta.splice(draggedIndex, 1);
      newSelectedMeta.splice(dropIndex, 0, draggedItem);
      if (isLanguage) {
        setSelectedLangMeta(newSelectedMeta);
      } else {
        setSelectedCategoryMeta(newSelectedMeta);
      }
      setSelectedMeta(newSelectedMeta);
    }
    setDraggedItem(null);
    setDragOverItem(null);
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
    setDragOverItem(null);
  };

  return (
    <div>
      {!isFromProductForm && (
        <div className="subHeader pageHeader">
          <div className="d-flex align-items-center">
            {showBackArrow && (
              <BackIcon
                className="bi bi-arrow-left"
                onClick={() => navigate("/setting")}
              ></BackIcon>
            )}
            <h5>{isLanguage ? "LANGUAGE" : "CATEGORY"}</h5>
          </div>
          <div className="d-flex align-items-center">
            <Button
              className="ms-2"
              type="outline-primary"
              onClick={() => setIsModalOpen(true)}
            >
              SAVE
            </Button>
          </div>
        </div>
      )}

      <div
        className="d-flex flex-column w-100"
        style={{ top: isFromProductForm ? "0px" : "50px", overflowY: "auto" }}
      >
        {!isFromProductForm && (
          <div className="d-flex flex-column  w-100 h-100">
            <div className="d-flex align-items-center gap-3">
              <span>Team/Property</span>
              <div style={{ width: "30%" }}>
                <CustomSelect
                  options={bunchProductList.map((item: any) => ({
                    label: formatEntityName(item),
                    value: item.name,
                  }))}
                  handleChange={(e) => setSelectedProduct(e)}
                  value={selectedProduct}
                  placeholder={"Select Team"}
                  className={"w-100"}
                />
              </div>
            </div>
          </div>
        )}
        {!isFromProductForm && <hr className="mt-3" />}
        {isFromProductForm ? (
          <div className="w-100">
            <Tabs
              defaultActiveKey="language"
              onSelect={(k) => {
                if (k === "language") {
                  handleClick("Language");
                } else if (k === "category") {
                  handleClick("Category");
                }
              }}
            >
              <Tab eventKey="language" title="Language">
                {/* Tab content will be handled by the existing logic */}
              </Tab>
              <Tab eventKey="category" title="Category">
                {/* Tab content will be handled by the existing logic */}
              </Tab>
            </Tabs>
          </div>
        ) : (
          <div className="scroll-container">
            {sections.map((link) => (
              <button
                key={link.to}
                onClick={() => handleClick(link.label)}
                className="card-link text-decoration-none"
                type="button"
              >
                <i className={`bi ${link.icon} icon-link`}></i>
                <span>{link.label}</span>
              </button>
            ))}
          </div>
        )}
      </div>

      {!isFromProductForm && (
        <div
          className="d-flex align-items-center justify-content-between p-3 border rounded mt-3"
          style={{ cursor: "pointer", backgroundColor: "#f8f9fa" }}
          onClick={() => setIsContentExpanded(!isContentExpanded)}
        >
          <span className="fw-bold fs-5">Meta Management</span>
          <i
            className={`bi ${
              isContentExpanded ? "bi-chevron-up" : "bi-chevron-down"
            }`}
          ></i>
        </div>
      )}

      {(isContentExpanded || isFromProductForm) && (
        <div
          className="row m-0 border py-3"
          style={{ height: "500px", overflowY: "auto" }}
        >
          <div
            id="category-list"
            className="border-end col-6 p-0"
            style={{ height: "500px", overflowY: "auto" }}
          >
            <div className="d-flex justify-content-between align-items-center border-bottom py-2">
              <span className="fs-5 ps-2">AVAILABLE LISTS</span>
              <button
                className="btn btn-sm btn-outline-primary me-2"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  const allItems = [...selectedMeta, ...filteredKeys];
                  setSelectedMeta(allItems);
                  if (isLanguage) {
                    setSelectedLangMeta(allItems);
                  } else {
                    setSelectedCategoryMeta(allItems);
                  }
                  setMetaList([]);
                  if (isLanguage) {
                    setLangMetaList([]);
                  } else {
                    setCategoryMetaList([]);
                  }
                }}
                title="Add all available items"
              >
                Add All
              </button>
            </div>
            <div className="d-flex align-items-center mt-3 border-bottom pb-3">
              <input
                type="text"
                className="form-control mx-3"
                placeholder="Search categories..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            {filteredKeys.length === 0 ? (
              <div className="text-muted text-center pt-4">
                No categories found.
              </div>
            ) : (
              filteredKeys.map((key) => {
                return (
                  <div
                    key={key.id}
                    className=" px-2 py-3 border-bottom  align-items-center catRow"
                  >
                    <div
                      className={`d-flex justify-content-between align-items-center`}
                    >
                      <span>{key.name}</span>
                      <div className="d-flex align-items-center gap-2">
                        <i
                          className="bi bi-plus-circle fs-5"
                          onClick={() => {
                            if (isLanguage) {
                              setSelectedLangMeta([...selectedLangMeta, key]);
                            } else {
                              setSelectedCategoryMeta([
                                ...selectedCategoryMeta,
                                key,
                              ]);
                            }
                            setSelectedMeta([...selectedMeta, key]);
                            const updatedList = isLanguage
                              ? langMetaList.filter(
                                  (item: any) => item.id !== key.id
                                )
                              : categoryMetaList.filter(
                                  (item: any) => item.id !== key.id
                                );
                            if (isLanguage) {
                              setLangMetaList(updatedList);
                            } else {
                              setCategoryMetaList(updatedList);
                            }
                            setMetaList(updatedList);
                          }}
                        ></i>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
          <div
            id="category-list"
            className="col-6 p-0"
            style={{ height: "500px", overflowY: "auto" }}
          >
            <div className="d-flex justify-content-between align-items-center border-bottom py-2">
              <span className="fs-5 p-2">SELECTED META</span>
            </div>
            <div className="d-flex align-items-center mt-3 border-bottom pb-3">
              <input
                type="text"
                className="form-control mx-2"
                placeholder="Search categories..."
                value={metaSearch}
                onChange={(e) => setMetaSearch(e.target.value)}
              />
            </div>
            {filteredMeta.length === 0 ? (
              <div className="text-muted text-center pt-4">
                No categories found.
              </div>
            ) : (
              filteredMeta.map((key: any) => {
                const isDragging = draggedItem && draggedItem.id === key.id;
                const isDragOver = dragOverItem && dragOverItem.id === key.id;

                return (
                  <div
                    key={key.id}
                    className={`px-2 py-3 border-bottom align-items-center ${
                      isDragging ? "opacity-50" : ""
                    } ${isDragOver ? "border-primary border-2" : ""}`}
                    draggable
                    onDragStart={(e) => handleDragStart(e, key)}
                    onDragOver={(e) => handleDragOver(e, key)}
                    onDragLeave={handleDragLeave}
                    onDrop={(e) => handleDrop(e, key)}
                    onDragEnd={handleDragEnd}
                    style={{
                      cursor: "grab",
                      backgroundColor: isDragOver ? "#f8f9fa" : "transparent",
                      transition: "all 0.2s ease",
                      transform: isDragging ? "rotate(2deg)" : "none",
                      boxShadow: isDragging
                        ? "0 4px 8px rgba(0,0,0,0.1)"
                        : "none",
                    }}
                  >
                    <div
                      className={`d-flex justify-content-between align-items-center`}
                    >
                      <div className="d-flex align-items-center">
                        <i
                          className="bi bi-grip-vertical me-2 fs-5"
                          style={{
                            cursor: "grab",
                            color: "#6c757d",
                          }}
                        ></i>
                        <span>{key.name}</span>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <i
                          className="bi bi-dash-circle fs-5 me-2"
                          onClick={(e) => {
                            handleDeleteMeta(e, key);
                            // let updatedList = metaList.filter((item: any) => item.id !== key.id);
                            if (isLanguage) {
                              setLangMetaList([...langMetaList, key]);
                            } else {
                              setCategoryMetaList([...categoryMetaList, key]);
                            }
                            setMetaList([...metaList, key]);
                          }}
                        ></i>
                        <i
                          className="bi bi-upload fs-5"
                          onClick={(e) => handleMoveUp(e, key)}
                        ></i>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const mapState = (state: RootState) => ({
  bunchProductList: state.constants.bunchProductList.list,
  bunchLanguageList: state.constants.bunchLanguageList.list,
  bunchCategoryList: state.constants.bunchCategoryList.list,
});

const mapDispatch = {
  createCategory,
  updateCategory,
  getCategoryList,
};

const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector>;
export default connector(MetaDefault);
